<script>
export default {
  name: "bhmfooter",
};
</script>

<template>
  <div class="footer">
    <div class="container small">
      <div class="row d-flex align-items-center">
        <div class="col-12 col-md-4 col-lg-3 col-xl-2 mb-5 mb-md-0">
          <a href="https://llu.edu"
            ><img src="images/llu_stack_rev_sm.png" class="img-fluid"
          /></a>
        </div>
        <div class="col-12 col-md-8 col-lg-9 col-xl-10">
          <div class="row">
            <h2 class="accent">Site credits</h2>
            <div class="col">
              <h3>360&deg; tour</h3>
              <ul class="list-unstyled">
                <li>Luis Luna</li>
              </ul>
            </div>
            <div class="col">
              <h3>Code</h3>
              <ul class="list-unstyled">
                <li>Flint Johnston</li>
              </ul>
            </div>
            <div class="col">
              <h3>Design</h3>
              <ul class="list-unstyled">
                <li>Nathan Hernandez</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.footer {
  margin-top: 100px;
  padding-top: 50px;
  padding-bottom: 50px;
  background: linear-gradient(
    123deg,
    rgba(144, 28, 59, 0.3) 0%,
    rgba(102, 102, 102, 0.3) 38%,
    rgba(0, 0, 0, 0.3) 100%
  ), black;
  font-size: 0.9rem;
  color: #ddd;

  img {
    max-height: 100px;
  }

  h2 {
    font-size: 14px;
  }

  h3 {
    font-size: 12px;
  }
}
</style>